import { useState } from 'react';
import styled from 'styled-components';
import client, { mensajeDeError } from '../../api/client';
import { useAuth } from '../../context/AuthContext';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { Campo, Etiqueta, Entrada, MensajeError, MensajeExito } from '../../components/ui/Form';

const Panel = styled(Card)`
  max-width: 480px;
`;

function Perfil() {
  const { usuario, actualizarUsuario } = useAuth();
  const [nombre, setNombre] = useState(usuario.nombre);
  const [telefono, setTelefono] = useState(usuario.telefono || '');
  const [error, setError] = useState('');
  const [exito, setExito] = useState('');
  const [guardando, setGuardando] = useState(false);

  const guardar = async (e) => {
    e.preventDefault();
    setError('');
    setExito('');
    setGuardando(true);
    try {
      const { data } = await client.put('/auth/me', { nombre, telefono });
      actualizarUsuario(data);
      setExito('Datos actualizados');
    } catch (err) {
      setError(mensajeDeError(err));
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Panel>
      {error && <MensajeError role="alert">{error}</MensajeError>}
      {exito && <MensajeExito role="status">{exito}</MensajeExito>}
      <form onSubmit={guardar}>
        <Campo>
          <Etiqueta htmlFor="nombre">Nombre</Etiqueta>
          <Entrada id="nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} required />
        </Campo>
        <Campo>
          <Etiqueta htmlFor="email">Email</Etiqueta>
          <Entrada id="email" value={usuario.email} disabled />
        </Campo>
        <Campo>
          <Etiqueta htmlFor="telefono">Teléfono</Etiqueta>
          <Entrada id="telefono" type="tel" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
        </Campo>
        <Button type="submit" disabled={guardando}>
          {guardando ? 'Guardando…' : 'Guardar cambios'}
        </Button>
      </form>
    </Panel>
  );
}

export default Perfil;
